export default {
  nav: {
    apartments: "Apartamentos",
    manifesto: "Manifiesto",
    map: "Mapa",
    contact: "Contacto",
    book: "Reservar",
    menu: "Menú",
  },
  lang: { es: "Español", en: "English", fr: "Français", de: "Deutsch" },
  hero: {
    kicker: "Alquiler temporal en Cádiz capital",
    line1: "Luz de Cádiz",
    line2: "apartamentos",
    sub: "Cuatro pisos perfectos para grupos de hasta 8 personas, en la playa Victoria o en el casco antiguo. Reserva directa, sin comisiones.",
    cta1: "Ver apartamentos",
    badge: "Teletrabajo y estancias de más de 1 mes: condiciones especiales",
    scroll: "Desliza",
  },
  manifesto: {
    kicker: "Manifiesto",
    chapters: [
      { n: "01", title: "La luz", text: "Hay una luz en Cádiz que no existe en ningún otro lugar: entra lateral, blanca, y lo vuelve todo nítido. Nuestras casas están pensadas para dejarla pasar." },
      { n: "02", title: "La sal", text: "El Atlántico se respira en cada calle. La Caleta, la Cortadura, el paseo marítimo: el mar nunca está a más de diez minutos de tu puerta." },
      { n: "03", title: "La cal", text: "Patios encalados, azulejo pintado a mano, piedra ostionera. Cuatro casas llenas de luz, cada una con su barrio y su carácter." },
    ],
  },
  gallery: {
    kicker: "La colección",
    title: "Cuatro casas, un mismo océano",
    sub: "Del Casco Antiguo a la Cortadura: elige tu Cádiz.",
    guests: "huéspedes",
    bedrooms: "dorm.",
    from: "desde",
    night: "noche",
    view: "Ver apartamento",
  },
  marquee: { items: ["Sal marina", "Puestas de sol", "Atlántico turquesa", "Pescaíto frito", "Piedra ostionera"] },
  map: {
    kicker: "El mapa",
    title: "Dónde dormir en Cádiz",
    sub: "Cuatro ubicaciones escogidas a mano, del casco histórico a la playa.",
    view: "Ver apartamento",
  },
  contact: {
    kicker: "Contacto",
    title: "Hablemos",
    sub: "Cuéntanos qué buscas y te respondemos en menos de 24 horas. También puedes escribirnos directamente por WhatsApp.",
    name: "Nombre",
    email: "Email",
    phone: "Teléfono (opcional)",
    message: "Mensaje",
    send: "Enviar mensaje",
    whatsapp: "Enviar por WhatsApp",
    success: "Mensaje enviado. Te respondemos en menos de 24 h.",
    error: "No se pudo enviar. Inténtalo de nuevo o escríbenos por WhatsApp.",
    response: "Respuesta en menos de 24 h",
  },
  footer: {
    tagline: "Cuatro apartamentos en Cádiz capital: Playa Victoria y Casco Antiguo.",
    rights: "Todos los derechos reservados.",
    seo: "Alquiler temporal en Cádiz · Apartamentos temporales en Cádiz capital · Pisos de alquiler temporal en Playa Victoria y Centro Histórico · Teletrabajo y trabajo en remoto junto al mar · Remote work in Cádiz · Estancias de más de un mes con ofertas especiales",
  },
  detail: {
    from: "desde",
    perNight: "/ noche",
    guests: "huéspedes",
    bedrooms: "dormitorios",
    baths: "baños",
    area: "m²",
    house: "La casa",
    amenities: "Comodidades",
    district: "El barrio",
    where: "Dónde está",
    openMaps: "Abrir en Google Maps",
    back: "Volver a la colección",
    notFound: "Apartamento no encontrado",
    longstayBadge: "Teletrabajadores · Estancias de más de 1 mes · Ofertas especiales — consulta precios y condiciones",
    mapBlocked: "Has rechazado las cookies de terceros, así que el mapa de Google no se carga aquí. Puedes abrir la ubicación directamente en Google Maps:",
  },
  booking: {
    title: "Reserva tu estancia",
    checkin: "Entrada",
    checkout: "Salida",
    nights: "noches",
    night: "noche",
    total: "Total",
    taxes: "Impuestos calculados en el pago",
    cta: "Reservar y pagar",
    whatsapp: "Consultar por WhatsApp",
    name: "Nombre completo",
    email: "Email",
    phone: "Teléfono",
    errDates: "Elige las fechas de entrada y salida",
    errFields: "Completa tu nombre, email y teléfono",
    errConflict: "Esas fechas acaban de ocuparse. Elige otras.",
    errGeneric: "No se pudo iniciar el pago. Inténtalo de nuevo.",
    secure: "Pago seguro con Stripe · Confirmación inmediata",
    legendFree: "Disponible",
    legendBusy: "Ocupado",
    loading: "Redirigiendo al pago…",
    dogs: "Perros",
    cribs: "Bebé (cuna)",
    cleaning: "Limpieza final",
    linen: "Sábanas y toallas",
    petsFee: "Mascotas",
    discountLine: "Descuento larga estancia (−{{pct}}%)",
    consult: "Para estancias de más de un mes tenemos ofertas especiales: consúltanos por WhatsApp",
    rateTitle: "Elige tu tarifa",
    rateFlex: "Tarifa flexible",
    rateStd: "Tarifa estándar",
    rateFlexPolicy: "24 h gratis · Hasta 15 días antes de la entrada: devolución del 90% (menos el depósito) · De 14 a 7 días antes: 50% · Desde 6 días antes: sin devolución",
    rateStdPolicy: "15% de descuento sobre el alojamiento · No reembolsable tras las primeras 24 h",
    depositNote: "Depósito de reserva: {{amount}} no reembolsable en ninguna tarifa a partir de las 24 h posteriores a la reserva.",
    datesTitle: "Cambiar fechas",
    nonrefLine: "Tarifa no reembolsable (−15% alojamiento)",
    linenOptional: "opcional",
    extrasNote: "Cunas y tronas gratis bajo petición · Camas y comederos para perros gratis bajo petición",
    helpEmailSubject: "Solicitud de reembolso · {{apartment}}",
    errSummer: "En julio y agosto la estancia mínima es de 4 noches (llevas {{nights}})",
    errWeekend: "Las noches de viernes y sábado deben reservarse juntas",
    altTitle: "Este piso no está libre en esas fechas. Estos sí tienen disponibilidad:",
    altDatesTitle: "Misma casa, fechas alternativas (mismas noches):",
    altNone: "Ningún otro piso está libre en esas fechas: escríbenos por WhatsApp y lo vemos.",
    openNote: "De momento las reservas online son para julio y agosto. Para otras fechas, escríbenos por WhatsApp.",
    closed: "Las fechas solicitadas están completas. Póngase en contacto con {{email}} para más información.",
    errOpenMonths: "De momento solo se pueden reservar online fechas de julio y agosto",
    payTitle: "Forma de pago",
    pay_card: "Tarjeta · Apple/Google Pay",
    pay_paypal: "PayPal",
    pay_bizum: "Bizum",
    feeService: "Gastos de gestión de pago (1%)",
    codePlaceholder: "¿Tienes un código de descuento?",
    codeApply: "Aplicar",
    codeOk: "Código aplicado: −{{pct}}%",
    codeInvalid: "Código no válido",
    codeApplied: "Código {{code}} (−{{pct}}%) aplicado",
    codeRemove: "Quitar",
    codeLine: "Código {{code}} (−{{pct}}%)",
  },
  success: {
    checking: "Confirmando tu reserva…",
    title: "Reserva confirmada",
    sub: "Te hemos enviado un email con los detalles. Nos vemos en Cádiz.",
    entry: "Entrada",
    exit: "Salida",
    nights: "Noches",
    total: "Total",
    whatsapp: "Avisar por WhatsApp",
    home: "Volver al inicio",
    pending: "Verificando el pago",
    pendingSub: "Estamos confirmando tu pago con el banco. Se actualizará en unos segundos.",
    sepaPending: "Hemos registrado tu domiciliación SEPA. El banco procesará el cargo en 1-3 días laborables y tu reserva se confirmará automáticamente por email.",
    rate: "Tarifa",
    rateFlex: "Flexible",
    rateNonref: "No reembolsable (−15%)",
    helpTitle: "¿Necesitas cancelar o pedir un reembolso?",
    helpWa: "Escribir por WhatsApp",
    helpEmail: "Enviar email",
  },
  search: {
    results: "Disponibilidad",
    cta: "Buscar",
    stay: "{{nights}} noches · {{guests}} huéspedes",
    totalStay: "Total estancia",
    book: "Ver y reservar",
    modify: "Modificar búsqueda",
    available: "Disponible",
    noneTitle: "Sin disponibilidad completa",
    noneSub: "Ningún piso está libre para esas fechas y ese número de huéspedes. Prueba otras fechas o escríbenos por WhatsApp.",
    noDates: "Ocupado en esas fechas",
    altDates: "Fechas alternativas para este piso",
    noCapacity: "Capacidad máxima: {{max}} huéspedes",
    unavailableTitle: "No disponibles para tu búsqueda",
    resultsFor: "Disponibles del {{from}} al {{to}}",
  },
  cancel: {
    title: "Reserva cancelada",
    sub: "No se ha realizado ningún cargo. Puedes intentarlo de nuevo cuando quieras.",
    back: "Volver a la colección",
  },
  amenities: {
    wifi: "Wifi de fibra",
    ac: "Aire acondicionado",
    kitchen: "Cocina equipada",
    washer: "Lavadora",
    tv: "TV",
    nespresso: "Nespresso",
    linen: "Ropa de cama y toallas opcionales",
    babykit: "Cunas y tronas gratis bajo petición",
    petkit: "Camas y comederos para perros gratis bajo petición",
    beachview: "Vistas despejadas a la playa",
    seaview: "Vistas parciales al mar",
    balcony: "Balcón al oeste",
    dryer: "Secador",
    iron: "Plancha",
    patio: "Patio andaluz privado",
    bbq: "Barbacoa portátil",
    terrace: "Terraza privada",
    parking: "Parking cercano",
    bikes: "Bicicletas incluidas",
    guide: "Guía local de autor",
    light: "Altillos con luz natural",
    lift: "Ascensor",
  },
  whatsapp: {
    floatLabel: "Escríbenos por WhatsApp",
    generic: "Hola, me interesa uno de vuestros apartamentos en Cádiz.",
    booking: "Hola, quiero consultar disponibilidad de {{apartment}} ({{checkin}} → {{checkout}}).",
    successMsg: "Hola, acabo de reservar {{apartment}} del {{checkin}} al {{checkout}}. ¡Gracias!",
    refund: "Hola, quiero solicitar la cancelación/reembolso de mi reserva en {{apartment}} ({{checkin}} → {{checkout}}).",
  },
  remote: {
    kicker: "Teletrabajo en Cádiz",
    title: "Trabaja en remoto frente al Atlántico",
    text: "Wifi de fibra, pisos amplios y luminosos y descuentos de hasta el 55% en estancias largas. ¿Más de un mes? Escríbenos y te hacemos una oferta especial para teletrabajadores.",
    cta: "Ver condiciones y contactar",
    waMsg: "Hola, teletrabajo y me interesa una estancia larga (más de un mes) en uno de vuestros pisos de Cádiz. ¿Qué ofertas especiales tenéis?",
  },
  longstay: {
    kicker: "Teletrabajo y largas estancias",
    title: "Trabaja en remoto frente al Atlántico",
    sub: "Cuatro pisos amplios y luminosos —junto a la playa o en el Centro Histórico— con wifi de fibra y todo lo necesario para vivir una temporada en Cádiz.",
    f1t: "Wifi de fibra",
    f1d: "Conexión rápida y estable para videollamadas y trabajo diario sin cortes.",
    f2t: "Espacios con luz",
    f2d: "Pisos grandes, exteriores y muy luminosos, con zonas cómodas para trabajar.",
    f3t: "Descuentos automáticos",
    f3d: "−30% desde 7 noches, −40% desde 8 y −55% desde 16, aplicados directamente al reservar.",
    f4t: "Más de un mes",
    f4d: "Escríbenos por WhatsApp o con el formulario y te hacemos una oferta especial para teletrabajadores.",
    note: "Alquiler temporal en Cádiz · Teletrabajo y trabajo en remoto junto al mar · Remote work in Cádiz",
  },
  instr: {
    kicker: "Reserva casi lista",
    title: "Completa tu pago",
    loading: "Cargando…",
    error: "No encontramos esta reserva. Escríbenos por WhatsApp.",
    amount: "Importe a pagar",
    ref: "Referencia",
    aptLabel: "Apartamento",
    datesLabel: "Fechas",
    bizumText: "Envía el importe por Bizum al {{phone}} indicando la referencia de la reserva.",
    transferText: "Te acabamos de enviar un email con los datos bancarios para la transferencia. Hazla indicando la referencia de la reserva.",
    paypalText: "Envía el importe por PayPal a {{email}} indicando la referencia de la reserva.",
    warning: "Importante: tu reserva queda PENDIENTE hasta que recibamos el pago. Las fechas no quedan bloqueadas en firme hasta entonces.",
    received: "En cuanto lo recibamos, te enviamos la confirmación por email.",
    whatsapp: "Avisar por WhatsApp",
    waMsg: "Hola, acabo de hacer el pago de mi reserva {{ref}} ({{apartment}}).",
  },
    paypal: {
    title: "Paga con PayPal",
    notCompleted: "El pago no se ha completado",
    error: "No se pudo procesar el pago con PayPal",
    notConfigured: "PayPal se está activando. Mientras tanto, escríbenos por WhatsApp y te damos otra forma de pago.",
  },
  cookies: {
    text: "Usamos cookies técnicas propias y de terceros (pagos con Stripe/PayPal y mapas de Google) para que la web funcione correctamente. No rastreamos ni vendemos tus datos.",
    accept: "Aceptar",
    reject: "Rechazar",
    more: "Más información",
  },
  rules: {
    title: "Normas de la casa",
    r1: "Entrada: 15:00 · Salida: 12:00",
    r2: "Sin ruidos a partir de las 22:00",
    r3: "No fumar en la casa, el portal ni los patios",
    r4: "Fianza de 300 € por semana: se cobra con el mismo medio de pago a la entrada, tras revisar juntos el estado de la casa, y se devuelve a la salida tras la revisión. Si algo no estuviera conforme al documento de estado que se entrega, comunícalo en las 12 h siguientes a la entrada.",
    r5: "Siempre que sea posible, tendremos en cuenta las necesidades de cada huésped.",
  },
  legal: {
    notice: "Aviso legal",
    privacy: "Privacidad",
    cookies: "Cookies",
    cancel: "Política de cancelación",
    terms: "Condiciones de la estancia",
  },
  checkin: {
    kicker: "Check-in online",
    notFound: "No encontramos esta reserva",
    backHome: "Volver a la web",
    doneTitle: "Check-in completado",
    doneText: "Ocupantes registrados, estado de la casa firmado y fianza bloqueada. Te esperamos el {{date}} a partir de las 15:00.",
    summary: "{{checkin}} → {{checkout}} · {{nights}} noches · {{guests}} huéspedes",
    step1: "1 · Datos de todos los ocupantes",
    step1Note: "Los exige el registro de viajeros (normativa española). Rellena los datos de cada persona que se alojará.",
    occupant: "Ocupante {{n}}",
    remove: "Quitar",
    firstName: "Nombre *",
    lastName: "Apellidos *",
    docId: "DNI / Pasaporte *",
    birthdate: "Fecha de nacimiento",
    nationality: "Nacionalidad",
    address: "Dirección habitual",
    addOccupant: "Añadir ocupante",
    step2: "2 · Estado de la casa",
    stateIntro: "El apartamento ha sido entregado en perfecto estado y con todo el inventario de menaje incluido. Me comprometo a revisarlo a la llegada.",
    stateDeadline: "Tengo 24 horas desde la entrada",
    stateRest: " para comunicar cualquier incidencia. Pasado este plazo, cualquier desperfecto o falta que aparezca podrá descontarse de la fianza. Firmando, acepto estas condiciones.",
    signReady: "Firma lista",
    signHint: "Dibuja tu firma con el dedo o el ratón",
    signClear: "Borrar",
    step3: "3 · Fianza ({{amount}} €)",
    depositText1: "{{perWeek}} € por semana. ",
    depositBold: "Solo se bloquea en tu tarjeta, no se cobra.",
    depositText2: " Se libera automáticamente tras la revisión de salida si está todo correcto.",
    depositOk: "Fianza bloqueada correctamente (no se ha cobrado nada)",
    depositRedirect: "Redirigiendo…",
    depositBtn: "Bloquear fianza de {{amount}} €",
    submit: "Enviar datos y firma",
    submitting: "Enviando…",
    submitted: "Datos y firma enviados ✓",
    help: "Cualquier duda: WhatsApp +34 667 39 67 67",
    errMissing: "Rellena al menos nombre, apellidos y documento de cada ocupante",
    errSignature: "Falta tu firma del estado de la casa",
    okSubmitted: "Check-in registrado correctamente",
    errSubmit: "No se pudo enviar el check-in",
    errDeposit: "No se pudo iniciar el bloqueo de la fianza",
  },
  reviews: {
    kicker: "Lo que dicen nuestros huéspedes",
    title: "Reseñas",
    sub: "Experiencias reales en nuestras casas de Cádiz.",
  },
};
